import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { ImageService } from '../services/imageService';
import {
    REAL_HEADER_LOGO_FILENAME, REAL_LOGIN_BACKGROUND_FILENAME,
    REAL_GENERAL_BACKGROUND_FILENAME, FALLBACK_LOGO_URL,
    SHOP_ITEM_IMAGE_FILENAMES, SHOP_ITEMS,
} from '../utils/constants';

const ImageContext = createContext();

export const useImages = () => useContext(ImageContext);

// Lista de todos os caminhos de imagem da lojinha para pré-carregamento
const SHOP_IMAGE_PATHS = [
    ...Object.values(SHOP_ITEM_IMAGE_FILENAMES),
    ...SHOP_ITEMS.map(cat => cat.image).filter(Boolean),
];

export const ImageProvider = ({ children }) => {
    const [images, setImages] = useState({
        logo: FALLBACK_LOGO_URL,
        loginBg: null,
        generalBg: null,
        loaded: false,
    });

    useEffect(() => {
        const loadGlobalImages = async () => {
            // Carrega as imagens críticas (visíveis imediatamente)
            const [logo, loginBg, generalBg] = await Promise.all([
                ImageService.getUrl(REAL_HEADER_LOGO_FILENAME),
                ImageService.getUrl(REAL_LOGIN_BACKGROUND_FILENAME),
                ImageService.getUrl(REAL_GENERAL_BACKGROUND_FILENAME),
            ]);

            setImages({
                logo: logo || FALLBACK_LOGO_URL,
                loginBg,
                generalBg,
                loaded: true,
            });

            // Pré-carrega imagens da lojinha em segundo plano (baixa prioridade)
            // Quando o usuário abrir a lojinha, as URLs já estarão no cache
            ImageService.preloadImages(SHOP_IMAGE_PATHS);
        };

        loadGlobalImages();
    }, []);

    // getImage estável — componentes que precisam de imagens sob demanda usam isso
    const getImage = useCallback((path) => ImageService.getUrl(path), []);

    return (
        <ImageContext.Provider value={{ ...images, getImage }}>
            {children}
        </ImageContext.Provider>
    );
};
